'use client';
import { useEffect, useState } from 'react';
import { getCurrentDateTime } from '@/utils/date/get-current-date-time';

export const CurrentTime = () => {
    const [currentTime, setCurrentTime] = useState<string>(getCurrentDateTime());

    useEffect(() => {
        const id = setInterval(() => {
            setCurrentTime(getCurrentDateTime());
        }, 1000);

        return () => {
            clearInterval(id);
        };
    }, []);

    return (
        <p suppressHydrationWarning data-test-id="footer-date-label">
            {currentTime}
        </p>
    );
};
